import { LoginPage, MsalLoginForm } from "am-tax-fe-core";
import BgImage from "../../assets/images/login_background.jpg";
import AmbientLogo from "../../assets/images/ambient_logo_white.png";
import { isInIframe } from "../../config/authConfig";
import { settings } from "../../utils/settings";

export const UnauthenticatedLandingPage = () => {
    return (
        <LoginPage bgImage={`url(${BgImage})`} appName={settings.VITE_APP_NAME} logo={<img src={AmbientLogo} alt="Ambient" style={{ maxHeight: "6rem" }} />}>
            <MsalLoginForm loginPopup={isInIframe()} />
        </LoginPage>
    );
};
